/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./widgetEditDialog.vue?vue&type=template&id=81f8eec0&scoped=true"
import script from "./widgetEditDialog.vue?vue&type=script&lang=js"
export * from "./widgetEditDialog.vue?vue&type=script&lang=js"
import style0 from "./widgetEditDialog.vue?vue&type=style&index=0&id=81f8eec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f8eec0",
  null
  
)

export default component.exports